module.exports = __webpack_public_path__ + "static/media/shirts9.40dae435.jpg";